import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.40204 3.49956C10.557 1.50015 13.4429 1.50015 14.5979 3.49956L21.5259 15.4996C22.681 17.4993 21.2378 19.9998 18.928 19.9998H5.07196C2.76222 19.9998 1.319 17.4995 2.47393 15.4998C2.47389 15.4998 2.47397 15.4997 2.47393 15.4998L9.40204 3.49956ZM11.1339 4.49994L4.20599 16.4997C3.82113 17.166 4.30177 17.9998 5.07196 17.9998H18.928C19.6981 17.9998 20.1789 17.1662 19.794 16.4999L12.866 4.49994C12.481 3.83335 11.5189 3.83335 11.1339 4.49994ZM12 7.99975C12.5522 7.99975 13 8.44747 13 8.99975V10.9998C13 11.552 12.5522 11.9998 12 11.9998C11.4477 11.9998 11 11.552 11 10.9998V8.99975C11 8.44747 11.4477 7.99975 12 7.99975ZM11 14.9998C11 14.4475 11.4477 13.9998 12 13.9998H12.01C12.5622 13.9998 13.01 14.4475 13.01 14.9998C13.01 15.552 12.5622 15.9998 12.01 15.9998H12C11.4477 15.9998 11 15.552 11 14.9998Z"
    />
  </svg>
);

const ExclamationIcon = (props) => <Icon component={SVG} {...props} />;

export default ExclamationIcon;
